var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasSanta = function SvgChristmasSanta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.438 20.14c1.164 1.774 4.638 2.42 6.287.442a.176.176 0 0 0 0-.219.18.18 0 0 0-.213-.055c-.231.1-.479.152-.73.152a2.145 2.145 0 0 1-2.164-1.804 1.837 1.837 0 0 0-3.18-1.218 1.837 1.837 0 0 0-3.18 1.218 2.145 2.145 0 0 1-2.164 1.804c-.251 0-.5-.052-.73-.152a.18.18 0 0 0-.214.055.176.176 0 0 0 .004.219c1.645 1.978 5.12 1.332 6.284-.443zm6.324-11.702-.614-1.345a1.333 1.333 0 0 1 1.437-1.864l3.988.657C18.287 4.788 14.23-.691 8.106 1.055c-3.464.99-5.057 3.772-5.786 7.383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.39 8.438a1.406 1.406 0 1 0 0-2.813 1.406 1.406 0 0 0 0 2.813m-5.624 0H2.109a1.406 1.406 0 1 0 0 2.812h12.657a1.406 1.406 0 0 0 0-2.813z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M5.977 14.063a.352.352 0 0 1 0-.704m0 .704a.352.352 0 0 0 0-.704m4.921.704a.352.352 0 0 1 0-.704m0 .704a.352.352 0 0 0 0-.704"
  })));
};
export default SvgChristmasSanta;